import { matchPath } from "react-router-dom";

/**
 * How wide a page may stand under the masthead, where it may not stop at the
 * one content width (`--content-max`, UX-Gutachten 1, B-7) — said on the
 * page and on the Vorgang's head above it as `data-breit`, so the two keep
 * one right edge (final review of the steel branch, I-1 and M-1).
 *
 * - `voll`: the review of a reading (`features/schema/review`). It is frozen
 *   in its layout for the M2 measurement windows until 09.11.2026: on `main`
 *   it took the whole window, and the original and the proposal a reviewer
 *   measures against stay as wide as they were — no cap at all.
 * - `werk`: the two drawing surfaces, the board and the outline. The drawing
 *   is the error detector (E-13); they keep the 110 rem they had on `main`
 *   (`--werk-max`).
 *
 * Every other page stops at the content width.
 */
export type PageWidth = "voll" | "werk";

/** The review of a reading — in a Vorgang, and the preview of the same screen. */
const FULL: readonly string[] = ["/vorgang/:caseId/schema", "/_vorschau/pruefung"];

/** The board and the outline — in a Vorgang, as the example, and the outline's preview. */
const WORK: readonly string[] = ["/vorgang/:caseId/planung", "/planung", "/umriss", "/_vorschau/umriss"];

export function pageWidth(pathname: string): PageWidth | undefined {
  const on = (patterns: readonly string[]) => patterns.some((pattern) => matchPath(pattern, pathname) !== null);
  if (on(FULL)) return "voll";
  if (on(WORK)) return "werk";
  return undefined;
}
